import DefaultModal from "Components/Modal/DefaultModal";
import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { memoData } from "../data";

export default function CommentsModal({ isOpen, setIsOpen }) {
	return (
		<DefaultModal
			modal={isOpen}
			header="Betuursmemo"
			headerColor={""}
			toggle={() => setIsOpen(false)}
			showFooterBtns={false}
			classes="modal-dialog__over feedback-modal-style planscreen__modal planscreen__modal--memo wc-500"
		>
			<ListGroup flush>
				<ListGroupItem
					className={`d-flex gap-3 p-0 bg-transparent`}
				>
					<div
						style={{ minWidth: "101px" }}
						className="py-2 d-flex gap-2 text-start"
					>
						Memo
					</div>
					<div className="py-2">{memoData[0].memo}</div>
				</ListGroupItem>
				<ListGroupItem
					className={`d-flex gap-3 p-0 bg-transparent`}
				>
					<div
						style={{ minWidth: "101px" }}
						className="py-2 d-flex gap-2 text-start"
					>
						Mobiel nummer
					</div>
					<div className="py-2">{memoData[0].mobielNumber}</div>
				</ListGroupItem>
				<ListGroupItem
					className={`d-flex gap-3 p-0 bg-transparent`}
				>
					<div
						style={{ minWidth: "101px" }}
						className="py-2 d-flex gap-2 text-start"
					>
						Woonplaats
					</div>
					<div className="py-2">{memoData[0].city}</div>
				</ListGroupItem>
				
			</ListGroup>
		</DefaultModal>
	);
}
